export const CARD_MIN_SCALE = 0.5
export const CARD_MAX_SCALE = 1.26
export const CARD_DEFAULT_SCALE = 1
export const DEFAULT_CARD_SIZE = 300
